<template>
  <div>
    <table-view
      ref="tableList"
      :isSearchLoading="isAllLoad"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      @pageChange="handlePageChange"
      :pages="page"
      @searchChange="handleSearchChange"
      tableCardTitle="Request History"
      :isSearchRow="false"
      :isTableLoading="isTableLoading"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
      <template v-slot:action="{ tableRow }">
        <a href="javascript:void(0)" @click="handleAction(tableRow.row)">
          <i class="el-icon-check"></i>
        </a>
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableList, getCssDetail } from './api'
import { getSelectList } from '@/api'
const selectList = ['Country', 'Region', 'CCA', 'Business', 'GEO']
const STATUS = [
  { id: 1, name: 'Pending' },
  { id: 2, name: 'Manual Approved' },
  { id: 3, name: 'Declined' },
  { id: 4, name: 'Cancelled' },
  { id: 6, name: 'Conditional Approval' },
  { id: 8, name: 'Field Action' },
]
export default {
  name: 'single-audit',
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      { label: 'Customer#', type: 'input', key: 'companyCode' },
      { label: 'Customer Name', type: 'input', key: 'companyName' },
      { label: 'GEO', type: 'select', key: 'geo', selectList: [] },
      { label: 'Region', type: 'select', key: 'region', selectList: [] },
      {
        label: 'Credit Category',
        type: 'select',
        key: 'type',
        selectList: [
          {
            id: 1,
            name: 'BAU',
          },
          {
            id: 2,
            name: 'Uplift',
          },
          {
            id: 3,
            name: 'Extension',
          },
          {
            id: 4,
            name: 'PCR',
          },
          {
            id: 5,
            name: 'Condition Update',
          },
          {
            id: 6,
            name: 'Waiver',
          },
          {
            id: 7,
            name: 'Invoice Extension',
          },
        ],
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        defaultValue: '',
        selectList: [
          { id: 1, name: 'Pending' },
          { id: 2, name: 'Manual Approved' },
          { id: 3, name: 'Declined' },
          { id: 4, name: 'Cancelled' },
          { id: 5, name: 'Waiting Auto Rules' },
          { id: 7, name: 'Auto Approved' },
        ],
      },
    ]
    const tableModel = [
      { slotName: 'bpmId', label: 'Trans#' },
      { prop: 'companyCode', label: 'Customer#' },
      { prop: 'typeStr', label: 'Credit Category' },
      { prop: 'companyName', label: 'Customer Name' },
      { prop: 'approver', label: 'Assigned To' },
      { prop: 'priorityStr', label: 'Priority' },
      { prop: 'region', label: 'Region' },
      { prop: 'geo', label: 'GEO' },
      { prop: 'statusStr', label: 'Status' },
      // { label: 'Action', slotName: 'action' },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      page: {},
      selectType: 'Region',
      isAllLoad: true,
      isTableLoading: true,
    }
  },
  created() {
    // 获取下拉列表
    this.getAllSelect()
  },
  mounted() {
    const fromHome = this.$route.query.fromHome
    if (fromHome) {
      const searchForm = this.$refs.tableList.getSearchForm()
      if (fromHome === 'pending') {
        // pending approval
        this.searchModel[6].defaultValue = 1
        searchForm.status = 1
        const _params = {
          ...searchForm,
          current: 1,
          size: 10,
        }
        this._getTableList(_params)
      }
      if (fromHome === 'approved') {
        // Approved
        this.searchModel[6].defaultValue = 2
        searchForm.status = 2
        const _params = {
          ...searchForm,
          current: 1,
          size: 10,
        }
        this._getTableList(_params)
      }
      if (fromHome === 'fail') {
        // Declined
        this.searchModel[6].defaultValue = 3
        searchForm.status = 3
        const _params = {
          ...searchForm,
          current: 1,
          size: 10,
        }
        this._getTableList(_params)
      }
      if (fromHome === 'cancel') {
        // Declined
        this.searchModel[6].defaultValue = 4
        searchForm.status = 4
        const _params = {
          ...searchForm,
          current: 1,
          size: 10,
        }
        this._getTableList(_params)
      }
    } else {
      const params = {
        current: 1,
        size: 10,
      }
      this._getTableList(params)
    }
  },
  methods: {
    async handleHrefInfoPage(tableRow) {
      this.$storage.setItem('bpmId', tableRow.bpmId)
      if (this.$store.state.source === 2) {
        // CSS
        // 根据status跳转;1为pending状态(跳到final);6为condition approved状态(跳到二次审核)
        const params = {
          bpmId: tableRow.bpmId || this.$storage.getItem('bpmId'),
        }
        const { running, creditInfo, additionalConditionsVOList, process } =
          await getCssDetail(params)
        if ([6, 8].includes(creditInfo.status)) {
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-second-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}&status=${tableRow.status}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else if (
          (creditInfo.status === 1 &&
            additionalConditionsVOList.length === 0 &&
            process.length === 2) ||
          (creditInfo.decisionType === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          (creditInfo.decisionType === 4 &&
            creditInfo.status === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          running === 1
        ) {
          // pending
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else {
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-final-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        }
        return
      }
      let routeUrl = this.$router.resolve({
        path: `/credit-management/credit-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
    },
    async _getTableList(params) {
      this.isTableLoading = true
      try {
        const res = await getTableList(params)
        const { data, page } = res
        if (this.$store.state.source === 1) {
          data.forEach(item => {
            item.source = 'lenovo'
          })
        } else {
          data.forEach(item => {
            item.source = 'CSS'
          })
          this.searchModel[6].selectList = STATUS
        }
        this.tableData = data
        this.page = page
        this.isTableLoading = false
      } catch (err) {
        console.log(err)
      }
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [countryList, regionList, ccaList, businessList, GeoList] =
              res
            for (let i = 0; i < this.searchModel.length; i++) {
              const item = this.searchModel[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = GeoList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.log(`search 列表查询错误:${err}`)
        })
    },
    // 每个type遍历请求
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.log(err)
      }
    },
    // 分页器页码改变
    handlePageChange(curPage) {
      const queryForm = {}
      const params = Object.assign({}, queryForm, {
        current: curPage.current,
        size: 10,
        status: curPage.status,
      })
      this._getTableList(params)
    },
    // search click callback
    handleSearchChange(params) {
      params.current = 1
      this._getTableList(params)
    },
  },
}
</script>

<style scoped lang="less">
.pageBox {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.el-icon-check {
  color: black;
}
</style>
